import {
  FETCH_IMPCS_OF_SINGLE_INBOUND_OPERATOR_REQUEST,
  FETCH_IMPCS_OF_SINGLE_INBOUND_OPERATOR_SUCCESS,
  FETCH_IMPCS_OF_SINGLE_INBOUND_OPERATOR_FAILURE,
  FETCH_IMPCS_OF_SINGLE_OUTBOUND_OPERATOR_REQUEST,
  FETCH_IMPCS_OF_SINGLE_OUTBOUND_OPERATOR_SUCCESS,
  FETCH_IMPCS_OF_SINGLE_OUTBOUND_OPERATOR_FAILURE,
} from './types/ImpcsOfSingleOperatorActionsTypes';

export function getImpcsOfSingleInboundOperatorRequestActionCreator(context, newOperatorCode) {
  return {
    type: FETCH_IMPCS_OF_SINGLE_INBOUND_OPERATOR_REQUEST,
    payload: {
      appContext: context,
      params: {
        operatorCode: newOperatorCode,
      },
    },
  };
}

export function getImpcsOfSingleInboundOperatorSuccessActionCreator(data) {
  return {
    type: FETCH_IMPCS_OF_SINGLE_INBOUND_OPERATOR_SUCCESS,
    payload: data,
  };
}

export function getImpcsOfSingleInboundOperatorFailureActionCreator(error) {
  return {
    type: FETCH_IMPCS_OF_SINGLE_INBOUND_OPERATOR_FAILURE,
    payload: error,
    error: true,
  };
}

export function getImpcsOfSingleOutboundOperatorRequestActionCreator(context, newOperatorCode) {
  return {
    type: FETCH_IMPCS_OF_SINGLE_OUTBOUND_OPERATOR_REQUEST,
    payload: {
      appContext: context,
      params: {
        operatorCode: newOperatorCode,
      },
    },
  };
}

export function getImpcsOfSingleOutboundOperatorSuccessActionCreator(data) {
  return {
    type: FETCH_IMPCS_OF_SINGLE_OUTBOUND_OPERATOR_SUCCESS,
    payload: data,
  };
}

export function getImpcsOfSingleOutboundOperatorFailureActionCreator(error) {
  return {
    type: FETCH_IMPCS_OF_SINGLE_OUTBOUND_OPERATOR_FAILURE,
    payload: error,
    error: true,
  };
}
